// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e6b13137","453":"7c255a1c"}[chunkId] + ".chunk.js";
};